import { z } from 'zod';

// System Notification form (doc 06 §4.4). Send stays disabled until a non-blank note is entered
// (parity SystemNotificationDialog.kt:108). Submitted via POST /admin/api/moderation/send-notification.
export const systemNotificationSchema = z.object({
  note: z.string().trim().min(1, 'Notification note is required'),
});

export type SystemNotificationForm = z.infer<typeof systemNotificationSchema>;
